// extracted by mini-css-extract-plugin
export default {"Privacy":"Privacy_Privacy__PpxJR","Logo":"Privacy_Logo__x0rA1"};